import React, { useEffect, useState } from "react";
import axios from "axios";

const API_BASE = process.env.REACT_APP_API_BASE_URL;

const VDGrid2Editor = () => {
  const SECTION_ID = 15104;

  const [form, setForm] = useState({
    TopRightTitleEn: "",
    TopRightTitleAr: "",
    TopRightTitleKu: "",

    TopRightDescEn: "",
    TopRightDescAr: "",
    TopRightDescKu: "",

    BottomLeftTitleEn: "",
    BottomLeftTitleAr: "",
    BottomLeftTitleKu: "",

    BottomLeftDescEn: "",
    BottomLeftDescAr: "",
    BottomLeftDescKu: "",
  });

  const [images, setImages] = useState({
    topLeft: null,
    bottomRight: null,
  });

  const [loading, setLoading] = useState(true);

  // Modal state
  const [showModal, setShowModal] = useState(false);
  const [uploadField, setUploadField] = useState(null);
  const [uploadFile, setUploadFile] = useState(null);

  const LANGS = ["En", "Ar", "Ku"];

  const resolveUrl = (url) =>
    url?.startsWith("http") ? url : `${API_BASE}${url}`;

  // ============================================================
  // LOAD DATA (3 LANGUAGES)
  // ============================================================
  useEffect(() => {
    const load = async () => {
      try {
        const [en, ar, ku] = await Promise.all([
          axios.get(`${API_BASE}/api/VDGrid2Section?lang=en`),
          axios.get(`${API_BASE}/api/VDGrid2Section?lang=ar`),
          axios.get(`${API_BASE}/api/VDGrid2Section?lang=ku`),
        ]);

        setForm({
          TopRightTitleEn: en.data.topRightTitle,
          TopRightTitleAr: ar.data.topRightTitle,
          TopRightTitleKu: ku.data.topRightTitle,

          TopRightDescEn: en.data.topRightDesc,
          TopRightDescAr: ar.data.topRightDesc,
          TopRightDescKu: ku.data.topRightDesc,

          BottomLeftTitleEn: en.data.bottomLeftTitle,
          BottomLeftTitleAr: ar.data.bottomLeftTitle,
          BottomLeftTitleKu: ku.data.bottomLeftTitle,

          BottomLeftDescEn: en.data.bottomLeftDesc,
          BottomLeftDescAr: ar.data.bottomLeftDesc,
          BottomLeftDescKu: ku.data.bottomLeftDesc,
        });

        setImages({
          topLeft: en.data.topLeftImage,
          bottomRight: en.data.bottomRightImage,
        });

        setLoading(false);
      } catch (err) {
        console.error("Failed to load VDGrid2:", err);
      }
    };

    load();
  }, []);

  const handleChange = (e) =>
    setForm({ ...form, [e.target.name]: e.target.value });

  // ============================================================
  // SAVE TEXT
  // ============================================================
  const handleSave = async () => {
    const token = localStorage.getItem("token");

    try {
      await axios.put(`${API_BASE}/api/VDGrid2Section/${SECTION_ID}`, form, {
        headers: { Authorization: `Bearer ${token}` },
      });

      alert("Saved successfully!");
    } catch (err) {
      console.error("Save failed:", err);
      alert("Failed to save.");
    }
  };

  // ============================================================
  // UPLOAD IMAGE
  // ============================================================
  const handleUpload = async () => {
    if (!uploadFile || !uploadField) return alert("Select a file first.");

    const token = localStorage.getItem("token");

    const fd = new FormData();
    if (uploadField === "topLeft") fd.append("TopLeftImage", uploadFile);
    if (uploadField === "bottomRight") fd.append("BottomRightImage", uploadFile);

    try {
      await axios.post(
        `${API_BASE}/api/VDGrid2Section/${SECTION_ID}/media`,
        fd,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      alert("Image updated!");
      setShowModal(false);
      window.location.reload();
    } catch (err) {
      console.error("Upload failed:", err);
      alert("Upload error.");
    }
  };

  if (loading) return <p>Loading...</p>;

  // ============================================================
  // RENDER
  // ============================================================
  return (
    <div className="container py-4">
      <h2 className="fw-bold mb-4">VOYAH DREAM – Grid 2 Editor</h2>

      {/* ============================================================
          TEXT INPUTS FOR 3 LANGUAGES
      ============================================================ */}
      <div className="row">
        {LANGS.map((lang) => (
          <div key={lang} className="col-lg-4 col-md-6 mb-4">
            <div className="card shadow-sm border-0 h-100">
              <div className="card-body">

                <h5 className="text-primary">{lang}</h5>

                {/* TOP RIGHT TITLE */}
                <label className="form-label mt-3">Top Right Title</label>
                <input
                  className="form-control"
                  name={`TopRightTitle${lang}`}
                  value={form[`TopRightTitle${lang}`]}
                  onChange={handleChange}
                />

                {/* TOP RIGHT DESC */}
                <label className="form-label mt-2">Top Right Description</label>
                <textarea
                  className="form-control"
                  rows={3}
                  name={`TopRightDesc${lang}`}
                  value={form[`TopRightDesc${lang}`]}
                  onChange={handleChange}
                />

                {/* BOTTOM LEFT TITLE */}
                <label className="form-label mt-3">Bottom Left Title</label>
                <input
                  className="form-control"
                  name={`BottomLeftTitle${lang}`}
                  value={form[`BottomLeftTitle${lang}`]}
                  onChange={handleChange}
                />

                {/* BOTTOM LEFT DESC */}
                <label className="form-label mt-2">Bottom Left Description</label>
                <textarea
                  className="form-control"
                  rows={3}
                  name={`BottomLeftDesc${lang}`}
                  value={form[`BottomLeftDesc${lang}`]}
                  onChange={handleChange}
                />

              </div>
            </div>
          </div>
        ))}
      </div>

      {/* SAVE BUTTON */}
      <div className="text-end mb-4">
        <button className="btn btn-primary px-4" onClick={handleSave}>
          Save Changes
        </button>
      </div>

      {/* ============================================================
          TOP LEFT IMAGE
      ============================================================ */}
      <h4 className="mb-3">Top Left Image</h4>
      <div className="card shadow-sm border-0 mb-4">
        <div className="card-body">

          {images.topLeft ? (
            <img
              src={resolveUrl(images.topLeft)}
              className="rounded w-100 mb-2"
              style={{ maxHeight: "260px", objectFit: "cover" }}
              alt=""
            />
          ) : (
            <p>No image uploaded.</p>
          )}

          <button
            className="btn btn-primary mt-2"
            onClick={() => {
              setUploadField("topLeft");
              setUploadFile(null);
              setShowModal(true);
            }}
          >
            Upload / Replace
          </button>
        </div>
      </div>

      {/* ============================================================
          BOTTOM RIGHT IMAGE
      ============================================================ */}
      <h4 className="mb-3">Bottom Right Image</h4>
      <div className="card shadow-sm border-0 mb-5">
        <div className="card-body">

          {images.bottomRight ? (
            <img
              src={resolveUrl(images.bottomRight)}
              className="rounded w-100 mb-2"
              style={{ maxHeight: "260px", objectFit: "cover" }}
              alt=""
            />
          ) : (
            <p>No image uploaded.</p>
          )}

          <button
            className="btn btn-primary mt-2"
            onClick={() => {
              setUploadField("bottomRight");
              setUploadFile(null);
              setShowModal(true);
            }}
          >
            Upload / Replace
          </button>
        </div>
      </div>

      {/* ============================================================
          MODAL UPLOAD
      ============================================================ */}
      {showModal && (
        <>
          <div className="modal fade show" style={{ display: "block" }}>
            <div className="modal-dialog">
              <div className="modal-content shadow">

                <div className="modal-header">
                  <h5 className="modal-title">Upload Image</h5>
                  <button className="btn-close" onClick={() => setShowModal(false)} />
                </div>

                <div className="modal-body">
                  <input
                    type="file"
                    className="form-control"
                    accept="image/*"
                    onChange={(e) => setUploadFile(e.target.files[0])}
                  />
                </div>

                <div className="modal-footer">
                  <button className="btn btn-secondary" onClick={() => setShowModal(false)}>
                    Cancel
                  </button>
                  <button className="btn btn-primary" onClick={handleUpload}>
                    Upload
                  </button>
                </div>

              </div>
            </div>
          </div>

          <div className="modal-backdrop fade show"></div>
        </>
      )}

    </div>
  );
};

export default VDGrid2Editor;
